module.exports = {
      id: "google-g-usage",
      viewBox: "0 0 46 46",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#google-g",
      toString: function () {
        return this.url;
      }
    }